( function( $ ) {

    primaryHovers();
    subHovers();
    // subClicks();

    /**
     * Primary hovering
     */
    function primaryHovers() {

        var $label = $('.js-header-link');
        $label.hover( function() {

            $(this).toggleClass( 'is-active' );


        } );
    }

    /**
     * Sub hovering
     */
    function subHovers() {

        var $links = $('.js-sub-menu-link');
        var $sections = $('.js-submenu-section');

        // Hover in
        $links.hover( function() {

            var id = this.dataset.section;
            var $section = $( document.getElementById( id ) );

            // Hide previously active sections
            $sections.not( $section ).removeClass( 'is-active' );
            $links.not( this ).removeClass( 'is-active' );

            // This is active
            $section.addClass( 'is-active' );
            $(this).addClass( 'is-active' );

        } );

        // Link click
        // $link.on( 'click', function( event ) {

        //     var id = $(this).attr( 'href' ); //.replace( '#', '' );
        //     var $section = $(id);

        //     $section.toggleClass( 'is-active' );


        // } );

        // Hover outs
        $('.js-submenu-section').mouseleave( function() {

            var id = $(this).attr( 'id' );
            var $link = $('.js-sub-menu-link[href="#' + id + '"]');

            $(this).removeClass( 'is-active' );
            $link.removeClass( 'is-active' );

        } );

        // Click Outs
        $(document).click( function( event ) {

            const $target = $(event.target);

            if( $target.parents( '.js-sub-menu-link' ).length < 1 && $target.parents( '.js-submenu-section' ).length < 1 ) {

                $links.removeClass( 'is-active' );
                $('.js-submenu-section').removeClass( 'is-active' );
            };

        } );
    }

    /**
     * Sub clicks.
     */
    // function subClicks() {
    //
    //   const $submenu_link = $( document.querySelectorAll( '.js-sub-menu-link' ) );
    //
    //   //$submenu_link.on( 'click', function( e ) {
    //
    //     //e.preventDefault();
    //
    //     // Data-section indicates that while hovering displays the associated section,
    //     // clicking the link
    //
    //
    //
    //   } );

    //}


} )( jQuery );


// WEBPACK FOOTER //
// ./assets/frontend/scripts/main/header-nav.js